import Filter from './Filter'

export default class Period extends Filter {
    filterComponent = import('@/views/components/filters/compoents/PeriodFilterComponent.vue')

    static YEAR = 'year'

    static QUARTER = 'quarter'

    static STATUS = 'status'

    static STEP = 'step'

    fields = {
      [Period.YEAR]: {
        label: 'Year',
      },
      [Period.QUARTER]: {
        label: 'Quarter',
      },
      [Period.STATUS]: {
        label: 'Status',
      },
      [Period.STEP]: {
        label: 'Step',
      },
    }
}
